import gsap from 'gsap';

var MobileSubnav = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

/**
 * Init
 * @return {[type]} [description]
 */
MobileSubnav.prototype.init = function(){

  var self = this;

	this.$collapseTrigger = this.options.$el.find(`.page-title`);
	this.$collapseIndicator = this.options.$el.find(`.arrow-right`);
	this.$collapsibleSubnav = this.options.$el.find(`.subnav-links-wrapper`);

	this.collapseTimeline = gsap.timeline({
		paused: true,
		defaults: {
			duration: 0.35
		}
	})
	.to(self.$collapsibleSubnav,
		{
			height: 'auto'
		}
	)
	.to(self.$collapseIndicator,
		{
			rotation: 90
		},
		"<"
	)
	.reverse()
	;

	this.$collapseTrigger.on('click', function() {

		self.collapseTimeline.reversed( !self.collapseTimeline.reversed() );

	});

};

export default  MobileSubnav;
